
import { Vue } from "vue-class-component";
import { Experience } from "@/assets/content/experience";

class Props {
  activeExperience!: Experience;
}

export default class ExperienceCard extends Vue.with(Props) {}
